import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPunkts } from '@cabinet-packages/redux';

const useCollectionPointsData = () => {
  const dispatch = useDispatch();
  const { punkts } = useSelector(store => store.collectionPoints);

  useEffect(() => {
    dispatch(getPunkts());
  }, [dispatch]);

  return {
    punkts: punkts || [],
    loading: !punkts,
    error: null,
  };
};

export default useCollectionPointsData;
